import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { vscDarkPlus } from "react-syntax-highlighter/dist/esm/styles/prism";
import "./style.css";
import { detaildatablogs } from "../../blogdetail.js";


const ContentRenderer = ({ text }) => {

  const processedText = text
    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
    .replace(/(https?:\/\/[^\s]+)/g, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>');

  return <li dangerouslySetInnerHTML={{ __html: processedText }} />;
};

export const BlogDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const blog = detaildatablogs.find((b) => b.id === Number(id));

  if (!blog) {
    return (
      <div className="container text-center py-5 text-white">
        <h2>Blog not found!</h2>
        <button onClick={() => navigate(-1)} className="btn btn-primary mt-3">
          ← Back to Blogs
        </button>
      </div>
    );
  }

  const renderSection = (section, index) => {
    switch (section.type) {
      case "heading":
        return (
          <h4 key={index} className="mt-4 border-start fw-bold border-info ps-3 text-info">
            {section.text}
          </h4>
        );

      case "paragraph":
        return <p key={index}>{section.content}</p>;

      case "list":
        return (
          <div key={index} className="my-3">
            {section.title && <h5>{section.title}</h5>}
            <ul className="list-styled">
              {section.items.map((item, i) => (
                <ContentRenderer key={i} text={item} />
              ))}
            </ul>
          </div>
        );

      case "code":
        const codeString = Array.isArray(section.code) ? section.code.join("\n") : section.code;
        return (
          <div key={index} className="my-3 code-block">
            <SyntaxHighlighter language={section.language} style={vscDarkPlus} >
              {codeString}
            </SyntaxHighlighter>
          </div>
        );
        
      case "image":
  return (
    <div key={index} className="text-center my-4">
      <img
        src={section.src}
        alt={section.alt_text || "Blog image"}
        className="img-fluid rounded shadow"
        style={{ maxHeight: "400px", objectFit: "cover" }}
      />
    </div>
  );


      default:
        return null;
    }
  };

  return (
    <div className={`blog-detail container py-2 blog-${blog.id}`} id={`blog-${blog.id}`}>
      <button onClick={() => navigate(-1)} className="btn btn-secondary mb-3">
        ← Back to Blogs
      </button>

      <div className="py-5 rounded-2 text-white mb-3">
        <h3>{blog.description}</h3>
      </div>
      
      <div className="blog-sections py-2 rounded-2 text-white">
        {blog.sections ? blog.sections.map(renderSection) : <p>{blog.content}</p>}
      </div>
    </div>
  );
};